import { TableRow as TableRowMui, TableRowProps as TableRowMuiProps } from '@mui/material';

export type TableRowProps = TableRowMuiProps;

export const TableRow = TableRowMui;
